import React, { useState, useEffect } from "react";
import api from "../api/homeapi";
import { StaffFrame, DataTable, PageHead, SearchBox, initials, T } from "./DashboardShared";
import { useNotify, errorMessage } from "../components/Notify";

const ROLE_STYLE = {
  ROLE_ADMIN:      { bg: "#FEE2E2", color: "#991B1B", label: "Admin" },
  ROLE_AGENT:      { bg: "#E6F0FB", color: "#1D4F91", label: "Agent" },
  ROLE_CONTROLLER: { bg: "#FFF1E0", color: "#B45309", label: "Contrôleur" },
  ROLE_PROGRAMMER: { bg: "#F3E8FF", color: "#6B21A8", label: "Programmateur" },
  ROLE_SUPPORT:    { bg: "#FEF3C7", color: "#92400E", label: "Support" },
  ROLE_CLIENT:     { bg: "#E8F5EE", color: "#006B3C", label: "Voyageur" },
};

export default function AdminUsers() {
  const notify = useNotify();
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");

  useEffect(() => {
    api.get("/api/admin/users")
      .then(r => setUsers(Array.isArray(r.data) ? r.data : []))
      .catch(e => notify.error(errorMessage(e, "Impossible de charger la liste des voyageurs.")))
      .finally(() => setLoading(false));
  }, [notify]);

  const q = search.trim().toLowerCase();
  const filtered = q
    ? users.filter(u => u.name?.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q) || u.phone?.includes(q))
    : users;

  return (
    <StaffFrame>
      <div className="page">
        <PageHead title="Voyageurs" sub={`${users.length} compte${users.length > 1 ? "s" : ""} enregistré${users.length > 1 ? "s" : ""}`}>
          <SearchBox value={search} onChange={setSearch} placeholder="Nom, email ou téléphone…" />
        </PageHead>

        {loading ? (
          <div className="loading-block"><div className="spinner"/>Chargement…</div>
        ) : (
          <DataTable stack="sm" rows={filtered} empty="Aucun voyageur trouvé." columns={[
            { key: "name", label: "Nom", main: true, render: u => (
              <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                <span className="sb-avatar" style={{ width: 34, height: 34, fontSize: 12 }}>{initials(u.name)}</span>
                <strong style={{ overflowWrap: "anywhere" }}>{u.name}</strong>
              </div>) },
            { key: "email", label: "Email", render: u => <span style={{ overflowWrap: "anywhere" }}>{u.email}</span> },
            { key: "phone", label: "Téléphone", nowrap: true, render: u => <span className="mono">{u.phone || "-"}</span> },
            { key: "role", label: "Rôle", render: u => {
              const role = u.roles?.find(r => r !== "ROLE_USER") || "ROLE_CLIENT";
              const rs = ROLE_STYLE[role] || ROLE_STYLE.ROLE_CLIENT;
              return <span className="status-pill" style={{ background: rs.bg, color: rs.color }}>{rs.label}</span>;
            } },
            { key: "id", label: "ID", render: u => <span className="mono" style={{ color: T.smoke }}>#{u.id}</span> },
          ]}/>
        )}
      </div>
    </StaffFrame>
  );
}
